import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';

@Component({
  standalone: true,
  selector: 'kc-chat-not-selected',
  imports: [
    FormsModule
  ],
  templateUrl: './chat-not-selected.component.html',
  styleUrl: './chat-not-selected.component.scss'
})
export class ChatNotSelectedComponent {

}

